import React from "react";
import { useTranslation } from "react-i18next";
import KnowledgeBaseEditor from "../KnowledgeBaseEditor";
import { AGENT_INSTRUCTIONS_MAX, AGENT_KB_INSTRUCTIONS_MAX } from "../agentPayload";
import { CharCounter, SectionTitle, TEXTAREA_CLS } from "./primitives";

// Instrucciones y conocimiento del agente: el prompt base (qué hace, cómo se
// comporta) más la base de conocimiento en tarjetas que el editor compila.
//
// El sistema SIEMPRE agrega sus reglas de seguridad y formato por encima; eso
// no es editable y se dice explícitamente para que nadie intente desactivarlo.

export default function PromptSection({ value, onChange }) {
  const { t } = useTranslation();

  return (
    <section className="space-y-4">
      <SectionTitle>{t("Instrucciones y conocimiento")}</SectionTitle>

      <div className="space-y-1">
        <div className="flex items-baseline justify-between gap-2">
          <label
            htmlFor="agent-instructions"
            className="hd-field-label block text-xs font-medium text-fg"
          >
            {t("Instrucciones del agente")}
          </label>
          <CharCounter value={(value.instructions || "").length} max={AGENT_INSTRUCTIONS_MAX} />
        </div>
        <textarea
          id="agent-instructions"
          rows={8}
          value={value.instructions}
          maxLength={AGENT_INSTRUCTIONS_MAX}
          onChange={(e) =>
            onChange({ instructions: e.target.value.slice(0, AGENT_INSTRUCTIONS_MAX) })
          }
          placeholder={t(
            "Ej.: Eres el asistente de soporte de la empresa. Responde en español, breve y cordial…",
          )}
          className={TEXTAREA_CLS}
        />
        <p className="text-[12px] md:text-[11px] text-fg-muted">
          {t("Qué hace este agente y cómo debe comportarse. Es lo primero que lee la IA.")}
        </p>
      </div>

      {/* Base de conocimiento en tarjetas + sus instrucciones generales. */}
      <KnowledgeBaseEditor
        entries={value.knowledge_base}
        instructions={value.kb_instructions}
        onChange={(entries) => onChange({ knowledge_base: entries })}
        onInstructionsChange={(text) =>
          onChange({ kb_instructions: (text || "").slice(0, AGENT_KB_INSTRUCTIONS_MAX) })
        }
      />

      <p className="text-xs text-fg-muted">
        {t("Beartrack añade reglas base de seguridad y formato que no se pueden desactivar.")}
      </p>
    </section>
  );
}
